import ImigrationReportIndex from "@/views/report/imigration/ImigrationReportIndex.vue";

const imigrationReport = [
    {
        path: '/imigration-report',
        name: 'imigration-report',
        component: ImigrationReportIndex
    }
]

export default imigrationReport;